import { 
    CampaignsService, 
    UserService, 
    UpdatesService
} from "../services";
import moment from "moment";
import { cpRequestUtils} from '../utils'
import { EMAIL_FUNCTION, HOST } from '../../firebase'
import axios from "axios";


export const getPartnerData = async (campaignId) => {
    const doc = await CampaignsService.getCampaignById(campaignId).get()

    return {
        ...doc.data(),
        id: doc.id,
    }
}

export const getOwnerCampaigns = async (authorId) => {
    const snapshot = await CampaignsService.getCampaignsByAuthorId(authorId).get()

    return snapshot.docs.map(
        doc => ({
            ...doc.data(),
            id: doc.id,
        })
    )
}

export const getUpdatesByCampaignId = async campaignId => {
    const snapshot = await UpdatesService.getUpdatesByCampaignId(campaignId).get()
    return snapshot.docs.map(
        doc => {
            const spot = {
                ...doc.data(),
                id: doc.id,
            }

            // spot.used = spot.uid === this.user.uid && spot.cpid = this.selected_campaign.id
            return spot
        }
    ).filter(
        (spot) => moment().isBefore(
            // + 86400 to show the current day
            moment.unix(spot.date.seconds + 86400)
        )
    ).sort((a,b) => a.date.seconds -  b.date.seconds)
}


export const preselectDate = (index, scheduler, campaignId) => {

    if (!scheduler[index]) {
        return
    }

    if(campaignId){
        if (!cpRequestUtils.isAlreadyRequestedDate(scheduler[index].spots, campaignId) && scheduler[index].spots.some(spot => !spot)) {
            return scheduler[index]
        }
    } else {
        if (scheduler[index].spots.some(spot => !spot)) {
            return scheduler[index]
        }
    }
    
    return preselectDate(index + 1, scheduler, campaignId)
};


export const sendRequestEmail = async (userId, messageText, owner) => {
    const userData = await UserService.getUserDoc('Users', userId).get()
    if(!userData.exists) {
        return
    }

    const { email, name, trial, subscription } = userData.data()

    if (!email) {
        return console.error('email not found!')
    }

    let {title, backers} = owner

    let subject = ''

    const trialExpired = trial && (!subscription ? 
            Date.now() > trial.endDate.seconds * 1000 :
            Date.now() > subscription.endDate.seconds*1000)

    let trialExpiredText = '.'

    switch(+backers){
        case 0: 
            subject = `You've got a new message from the campaign ${title}`
            break
        case 1: 
            subject = 'Your campaign can be featured in a 1 backer update newsletter'
            title = `<b>${title}</b> with <b>1 backer</b>`
            trialExpiredText = ` from the campaign with <b>1 backer</b>.`
            break
        default: 
            subject = `Your campaign can be featured in ${backers} backers update newsletter`
            title = `<b>${title}</b> with <b>${backers} backers</b>`
            trialExpiredText = ` from the campaign with <b>${backers} backers.`
    }

    let text = `You've got a new message from the campaign ${title}. Here's what they wrote to you`

    if(trialExpired) {
        text = "You've got a new message" + trialExpiredText
    }

    // email notification
    axios.post(EMAIL_FUNCTION, {
        email,
        subject,
        templateName: 'newRequest',
        tag: 'requests-notifications',
        templateData: { 
            name,
            text,
            trialExpired,
            tag: 'requests-notifications',
            comment: messageText,
            url: trialExpired ? `${HOST}/pricing` : `${HOST}/mymessages`,
            action: trialExpired ? `Unlock Message` : 'Reply'
        }
    })
}

